var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 7.49992C7.33203 7.13173 7.63051 6.83325 7.9987 6.83325C8.36689 6.83325 8.66536 7.13173 8.66536 7.49992V11.4999C8.66536 11.8681 8.36689 12.1666 7.9987 12.1666C7.63051 12.1666 7.33203 11.8681 7.33203 11.4999V7.49992Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 4.21444C7.63051 4.21444 7.33203 4.51291 7.33203 4.8811C7.33203 5.24929 7.63051 5.54777 7.9987 5.54777C8.36689 5.54777 8.66536 5.24929 8.66536 4.8811C8.66536 4.51291 8.36689 4.21444 7.9987 4.21444Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 1.51367C4.3168 1.51367 1.33203 4.49844 1.33203 8.18034C1.33203 11.8622 4.3168 14.847 7.9987 14.847C11.6806 14.847 14.6654 11.8622 14.6654 8.18034C14.6654 4.49844 11.6806 1.51367 7.9987 1.51367ZM2.66536 8.18034C2.66536 11.1259 5.05318 13.5137 7.9987 13.5137C10.9442 13.5137 13.332 11.1259 13.332 8.18034C13.332 5.23482 10.9442 2.84701 7.9987 2.84701C5.05318 2.84701 2.66536 5.23482 2.66536 8.18034Z",
    fill: "#7B7B7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.955d6f816d85769c40ea8fd544af881b.svg";
export { ForwardRef as ReactComponent };